// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".designation-editor-paragraph-text{min-height:90px}", "",{"version":3,"sources":["webpack://./src/app/designationEditor/designationEditor.scss"],"names":[],"mappings":"AAAA,mCACE,eAAA","sourcesContent":[".designation-editor-paragraph-text{\n  min-height: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
